import { useLang } from '@/i18n';
import css from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ItfItem } from './type';
import { useEffect, useState } from 'react';

const E: React.FC = () => {
    const { t } = useLang('ces2026.E');
    const [gap, setGap] = useState(12);
    const [active, setAcitve] = useState([false, false, false]);
    const items: ItfItem[] = [
        {
            name: t('item1_name'),
            text: [t('item1_text1')],
            img: ['https://websiteoss.ecoflow.com/upload/image/1765346010971/E_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1765346010806/E_1_m.jpg'],
        },
        {
            name: t('item2_name'),
            text: [t('item2_text1'), t('item2_text2')],
            img: ['https://websiteoss.ecoflow.com/upload/image/1765346011182/E_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1765346011736/E_2_m.jpg'],
        },
        {
            name: t('item3_name'),
            text: [t('item3_text1'), t('item3_text2')],
            img: ['https://websiteoss.ecoflow.com/upload/image/1765346011578/E_3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1765346011336/E_3_m.jpg'],
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window?.innerWidth > 1440 ? 81 : window?.innerWidth >= 1024 ? 40 : 12);
            const scenes: any[] = [];
            ['box2'].map((cls: string) => {
                scenes.push(
                    AniContainer.create({
                        triggerElement: `.${css.section} .${cls}`,
                        triggerHook: 1,
                        offset: '30%',
                        duration: '10%',
                        syncFromTo: [[`.${css.section} .cover`, { opacity: 0 }, { opacity: 1 }, 0.5]],
                    }),
                );
            });
            // const el: HTMLDivElement | null = document.querySelector('.ces-2026-D');
            // if (el) {
            //     scenes.push(
            //         AniContainer.create({
            //             triggerElement: el,
            //             triggerHook: 1,
            //             offset: el.offsetHeight,
            //             duration: '50%',
            //             syncFromTo: [
            //                 ['.ces-2026-E', { y: window.innerHeight / 2 }, { y: 0 }],
            //                 ['.ces-2026-D .box-inner', { opacity: 1 }, { opacity: 0 }],
            //             ],
            //         }),
            //     );
            // }
            return () => scenes?.forEach((scene: any) => scene && scene?.destroy());
        }
    }, []);

    const handleToggleName = (i: number) => {
        const newA = JSON.parse(JSON.stringify(active));
        newA[i] = !active[i];
        setAcitve(newA);
    };

    return (
        <div id="ces-2026-E" className={`ces-2026-E ${css.section} GtmModuleData-section`} data-section-id={'ces-2026-E'}>
            <div className="sticky-img">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1765337237940/E.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1765337238156/E_pad.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1765337237762/E_m.jpg"
                />
                <div className="cover"></div>
            </div>
            <div className="box1">
                <div className="info">
                    <h2 className="title-big">{t('title')}</h2>
                    <p className="desc">{t('desc')}</p>
                </div>
                <div className="msg">
                    <h3 className="title">{t('name')}</h3>
                    <div className="desc">{t('text')}</div>
                </div>
            </div>
            <div className="box2">
                <Swiper className="items" slidesPerView={'auto'} spaceBetween={gap}>
                    {items?.map((item: ItfItem, i: number) => (
                        <SwiperSlide className="item" key={i}>
                            <div className="item-img">
                                <EcoImg pc={item.img[0]} h5={item.img[1]} />
                            </div>
                            <div className="item-name name" onClick={() => handleToggleName(i)}>
                                <h3 className="name-text">{item.name}</h3>
                                <svg
                                    className={`name-svg ${active[i] ? 'active' : ''}`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="1em"
                                    height="1em"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path d="M18 9L12 15L6 9" stroke="#F5F5F6" stroke-width="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <ul className={`item-texts ${active[i] ? 'active' : ''}`}>
                                {item.text?.map((txt: string, j: number) => (
                                    <li className="item-text text" key={`${i}-${j}`}>
                                        {txt}
                                    </li>
                                ))}
                            </ul>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default E;
